module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAARElEQVQ4y2P4jwQ+MAww7wADDNgPPI8f7Cjm/4OBB3QTxHmDgzd44ugPkAEMqEHCQ46/AeUxMP8HJ6FBwRs86WXwlHUAHz/GR1fgb+MAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6MjY6NDMrMDk6MDB5Ddv1AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjI2KzA5OjAwy+cM3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00428_100x100.png
// module id = +51W
// module chunks = 0